import { lazy } from "react";
import withSuspense from "../../../helpers/withSuspense";
import LexicalSkeleton from "./LexicalSkeleton.jsx";

export const BLANK_CONTENT = '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}'
const LexicalDiscussionEditor = withSuspense(lazy(()=>import('./LexicalDiscussionEditor.jsx')), LexicalSkeleton);

export default LexicalDiscussionEditor;